// extracted by mini-css-extract-plugin
module.exports = {"hidden":"dimm_hidden__I5QJj","textEmphasis":"dimm_textEmphasis__CKfnT","dimm":"dimm_dimm__u4zFR","content":"dimm_content__xkJ9k","button":"dimm_button__aJiPP"};